import { useEffect } from 'react';

import PropTypes from 'prop-types';

import SplitterContainer from '../../Splitter/SplitterContainer';
import CommunityMessagesSellerListContainer from './CommunityMessagesSellerListContainer';
import CommunityMessagesWidgetContainer from './CommunityMessagesWidgetContainer';

const CommunityMessagesComponent = (props) => {
  const { hasSelectedChat, getThreadsList } = props;

  useEffect(() => {
    getThreadsList({}, true);
  }, []);

  return (
    <SplitterContainer
      hasSelectedItem={hasSelectedChat}
      MainComponent={CommunityMessagesSellerListContainer}
      mainComponentProps={props}
      DependentComponent={CommunityMessagesWidgetContainer}
      dependentComponentProps={props}
    />
  );
};

CommunityMessagesComponent.defaultProps = {
  hasSelectedChat: false,
};

CommunityMessagesComponent.propTypes = {
  hasSelectedChat: PropTypes.bool,
  getThreadsList: PropTypes.func.isRequired,
};

export default CommunityMessagesComponent;
